import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateDataItemDocument } from './update.generated';

export const useUpdateDataItem = (options: ApiOptions<typeof UpdateDataItemDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(UpdateDataItemDocument, {
    ...useNotifications(UpdateDataItemDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.data_items.update_success'),
    }),
    ...options,
  });
};
